export interface StatusMapping {
  bg: string;
  dot: string;
  titleKey: string;
  namespace?: string;
}

export const AMENDMENT_STATUS_MAPPING: Record<string, StatusMapping> = {
  draft: {
    bg: "bg-blue-500/40",
    dot: "bg-blue-500",
    titleKey: "statusIndicator.amendment.draft",
  },
  cancelled: {
    bg: "bg-red-500/40",
    dot: "bg-red-500",
    titleKey: "statusIndicator.amendment.cancelled",
  },
  applied: {
    bg: "bg-green-500/40",
    dot: "bg-green-500",
    titleKey: "statusIndicator.amendment.applied",
  },
};

export const AMENDMENT_DEFAULT: StatusMapping = {
  bg: "bg-orange-500/40",
  dot: "bg-orange-500",
  titleKey: "statusIndicator.amendment.default",
};

export const JOB_APPLICATION_STATUS_MAPPING: Record<string, StatusMapping> = {
  contract_signed: {
    bg: "bg-blue-500/40",
    dot: "bg-blue-400",
    titleKey: "statusIndicator.jobApplication.contractSigned",
  },
  decision: {
    bg: "bg-red-500/40",
    dot: "bg-red-500",
    titleKey: "statusIndicator.jobApplication.decision",
  },
  job_app_pending: {
    bg: "bg-orange-500/40",
    dot: "bg-orange-500",
    titleKey: "statusIndicator.jobApplication.jobAppPending",
  },
  job_app_review: {
    bg: "bg-orange-500/40",
    dot: "bg-orange-500",
    titleKey: "statusIndicator.jobApplication.jobAppReview",
  },
};

export const JOB_APPLICATION_DEFAULT: StatusMapping = {
  bg: "bg-green-500/40",
  dot: "bg-green-500",
  titleKey: "statusIndicator.jobApplication.default",
};

export const SIGNING_STATUS_INDICATOR_MAPPING: Record<string, StatusMapping> = {
  "0": { bg: "bg-blue-500/40", dot: "bg-blue-500", titleKey: "signingStatus.notSigned" },
  "1": { bg: "bg-orange-500/40", dot: "bg-orange-500", titleKey: "signingStatus.signedByCompany" },
  "2": { bg: "bg-orange-500/40", dot: "bg-orange-500", titleKey: "signingStatus.signedByClient" },
  "3": { bg: "bg-green-500/40", dot: "bg-green-500", titleKey: "signingStatus.fullySigned" },
  "4": { bg: "bg-red-500/40", dot: "bg-red-500", titleKey: "signingStatus.revokedByCompany" },
  "9": { bg: "bg-red-500/40", dot: "bg-red-500", titleKey: "signingStatus.clientRefusedToSign" },
};

export const ORDER_STATUS_MAPPING: Record<string, StatusMapping> = {
  order_pending: {
    bg: "bg-orange-500/40",
    dot: "bg-orange-500",
    titleKey: "statusIndicator.order.orderPending",
  },
};

export const ORDER_DEFAULT: StatusMapping = {
  bg: "bg-green-500/40",
  dot: "bg-green-500",
  titleKey: "statusIndicator.order.default",
};

export const LEGACY_UPLOADED_DEFAULT: StatusMapping = {
  bg: "bg-green-500/40",
  dot: "bg-green-500",
  titleKey: "",
};

export const HANDOVER_STATUS_MAPPING: Record<string, StatusMapping> = {
  draft: {
    bg: "bg-blue-500/40",
    dot: "bg-blue-500",
    titleKey: "statusIndicator.handover.draft",
  },
  pending_signing: {
    bg: "bg-orange-500/40",
    dot: "bg-orange-500",
    titleKey: "statusIndicator.handover.pendingSigning",
  },
  signed: {
    bg: "bg-green-500/40",
    dot: "bg-green-500",
    titleKey: "statusIndicator.handover.signed",
  },
  revoked: {
    bg: "bg-red-500/40",
    dot: "bg-red-500",
    titleKey: "statusIndicator.handover.revoked",
  },
};

export const HANDOVER_DEFAULT: StatusMapping = {
  bg: "bg-orange-500/40",
  dot: "bg-orange-500",
  titleKey: "statusIndicator.handover.default",
};
